// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".answers{margin-bottom:30px}.questionLabel{font-weight:bold}", "",{"version":3,"sources":["webpack://./src/styles/QuestionComponent.scss"],"names":[],"mappings":"AAAA,SACI,kBAAA,CAEJ,eACI,gBAAA","sourcesContent":[".answers {\r\n    margin-bottom: 30px;\r\n}\r\n.questionLabel{\r\n    font-weight:bold;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
